import { useState, useEffect } from 'react';
import api from 'services/api';

export default function SystemStatus() {
  const [status, setStatus] = useState('ok');

  useEffect(() => {
    const check = async () => {
      const start = performance.now();
      try {
        await api.get('/auth/me');
        const elapsed = performance.now() - start;
        setStatus(elapsed > 3000 ? 'slow' : 'ok');
      } catch {
        setStatus('down');
      }
    };
    check();
    const interval = setInterval(check, 30000);
    return () => clearInterval(interval);
  }, []);

  const labels = { ok: 'Systeme operationnel', slow: 'Connexion lente', down: 'Serveur deconnecte' };
  const colors = { ok: '#1A8754', slow: '#D97706', down: '#DC2626' };

  return (
    <div className="system-status" title={labels[status]}>
      <span className="system-dot" style={{ background: colors[status] }} />
      <span className="system-label" style={{ color: colors[status] }}>{labels[status]}</span>
    </div>
  );
}
